import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import decode from 'jwt-decode'
const tokenAttrs = (function () {
  if (localStorage.getItem('token')) {
    const decoded = decode(localStorage.getItem('token'))
    return {
      token: localStorage.getItem('token'),
      userRole: decoded.roles[0],
      userSocieteId: decoded.societeId,
      userId: decoded.id,
      expireDate: decoded.exp,
      firstName: decoded.prenom,
      name: decoded.nom,
      societeNom: decoded.societeNom
    }
  } else {
    return {
      token: '',
      userRole: '',
      userSocieteId: 0,
      userId: 0,
      expireDate: 0,
      firstName: '',
      name: '',
      societeNom: ''
    }
  }
})()

export default {
  state: {
    status: '',
    user: {},
    societeLists: [],
    ...tokenAttrs
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login/index.js